import { render, staticRenderFns } from "./collectInfoCard.vue?vue&type=template&id=3f38365e&scoped=true"
import script from "./collectInfoCard.vue?vue&type=script&lang=js"
export * from "./collectInfoCard.vue?vue&type=script&lang=js"
import style0 from "./collectInfoCard.vue?vue&type=style&index=0&id=3f38365e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38365e",
  null
  
)

export default component.exports